var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731411519246,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1469,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M627.2 224C268.8 262.4 256 665.6 256 665.6c115.2-192 204.8-262.4 428.8-262.4V576L896 416v256c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64v-384c0-38.4 25.6-64 64-64h435.2z",
    fill: "#d6f6eb",
    "p-id": 1470,
    "data-spm-anchor-id": "a313x.search_index.0.i2.c7733a817Ejdc0",
    className: "selected"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 256H192c-38.4 0-64 25.6-64 64v384c0 38.4 25.6 64 64 64h640c38.4 0 64-25.6 64-64V448l64-51.2V704c0 70.4-57.6 128-128 128H192c-70.4 0-128-57.6-128-128V320c0-70.4 57.6-128 128-128h192c0 38.4-25.6 64-64 64H256z m556.8-64h19.2c64 0 115.2 51.2 128 108.8L812.8 192z m-140.8 0H768v64h-96c-19.2 0-32-12.8-32-32s12.8-32 32-32z",
    fill: "#2e8f79",
    "p-id": 1471,
    "data-spm-anchor-id": "a313x.search_index.0.i1.c7733a817Ejdc0",
    className: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M684.8 371.2v172.8l339.2-256L684.8 25.6v160c-409.6 0-428.8 448-428.8 448 115.2-192 204.8-262.4 428.8-262.4z",
    fill: "#2e8f79",
    "p-id": 1472,
    "data-spm-anchor-id": "a313x.search_index.0.i0.c7733a817Ejdc0",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.14eef05fff3048b1dde40edb893bcc36.svg";
export { ForwardRef as ReactComponent };